import {
  ResolvedChatMessage,
  ResolvedCreateProgramsToolCallResult,
  TOOL_CALL_USER_RESULT_OK,
  TOOL_CREATE_PROGRAMS,
  TOOL_UPDATE_BUSINESS_PLAN_SECTION,
} from '../../../growegy-ai/types';
import useAuth from '../../../auth/authContext';
import { ProgramCalendarEvent } from '../calendar/ProgramCalendarEvent';
import { UnscheduledViewType } from '../../containers/types';
import { ResolvedProgramDatesField, ResolvedProgramOwnerField } from '../../types';
import React, { useState } from 'react';
import ProgramDialog, { ModalState } from '../../containers/ProgramDialog';
import { unresolveProgramSummary } from '../../util';
import { v4 as uuidv4 } from 'uuid';
import _ from 'lodash';

const CreateProgramsToolCallResult = (props: {
  resolvedToolCallResults: ResolvedCreateProgramsToolCallResult[];
}) => {
  const { resolvedToolCallResults } = props;

  const {
    state: { user },
  } = useAuth();

  const [modalState, setModalState] = useState<ModalState>(null);
  const createdPrograms = resolvedToolCallResults.flatMap((x) => x.content.created_programs) ?? [];

  if (!user) return null;
  return (
    <>
      <div>
        {createdPrograms.length > 0
          ? 'Here is the list of created program(s):'
          : 'No programs were created.'}
      </div>
      {createdPrograms.map((x, index) => (
        <div className="program-calendar__program-underlayer" key={`create_program_${index}`}>
          <ProgramCalendarEvent
            program={x}
            user={user}
            onClick={() =>
              setModalState({
                key: uuidv4(),
                program: unresolveProgramSummary(x),
                action: 'UPDATE',
                scrollToTaskId: null,
                taskToDeleteOnCreate: null,
              })
            }
            showCampaigns={false}
            applicableVisibleColumns={[ResolvedProgramDatesField, ResolvedProgramOwnerField]}
            viewType={UnscheduledViewType}
            shortcutFieldNamesOnly={false}
          />
        </div>
      ))}
      {modalState && (
        <ProgramDialog
          key={modalState.key}
          action={modalState.action}
          programSummary={modalState.program}
          scrollToTaskId={modalState.scrollToTaskId}
          onHide={() => {}}
        />
      )}
    </>
  );
};

export const ToolCallResultMessageContent = (props: { message: ResolvedChatMessage }) => {
  const { message } = props;

  if (
    message.resolvedToolCallResults &&
    message.resolvedToolCallResults.length > 0 &&
    message.resolvedToolCallResults.every((x) => x.content.user_result !== TOOL_CALL_USER_RESULT_OK)
  ) {
    return <span>No problem, just let me know what you want to modify.</span>;
  }
  return (
    <div className="message-list__tool-calls-container">
      {_(message.resolvedToolCallResults)
        .groupBy((x) => x.name)
        .map((toolCallResults, name) => {
          switch (name) {
            case TOOL_CREATE_PROGRAMS:
              return (
                <CreateProgramsToolCallResult
                  key={name}
                  resolvedToolCallResults={
                    toolCallResults as ResolvedCreateProgramsToolCallResult[]
                  }
                />
              );
            case TOOL_UPDATE_BUSINESS_PLAN_SECTION:
              return <div key={name}>Done.</div>;
            default:
              return null;
          }
        })
        .value()}
    </div>
  );
};
